import { useUsageQuery } from '../api/queries/useUsageQuery';
import { useCountdown } from '../hooks/useCountdown';

export function UsageCountdown({ active }: { active: boolean }) {
    const { data } = useUsageQuery();
    console.log({ data });

    if (!data) {
        return null;
    }
    const start = Math.ceil(data.limit - data.usage);

    return <Countdown start={start} active={active} />;
}

function Countdown(props: { start: number; active: boolean }) {
    const { time } = useCountdown(props.start, props.active);

    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    if (time < 0) {
        return <span className="text-orange-2 z-10">00:00:00</span>;
    }

    return (
        <span className="text-orange-2 z-10">
            {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </span>
    );
}
